import React, { useEffect, useState } from 'react';
// @ts-ignore
import './App.css';
import { Route, Routes, useNavigate } from 'react-router-dom';
import MainPage from './components/MainPage';
import Login from './components/login/Login';
import ProtectedRoute from './components/ProtectedRoute';
import Error404 from './components/Error404';
import Error500 from './components/Error500';
import MaintenanceMode from './components/MaintenanceMode';
import ComingSoon from './components/ComingSoon';
import { useAppDispatch, useAppSelector } from './app/Hooks';
import { useGetDashboardQuery } from './app/slices/sliceLogApi';
import { tokenReducer } from './app/slices/loginSlice';
import { dataReducer } from './app/slices/dataSlice';
import { loadingReducer } from './app/slices/pagesSlice';

const App: React.FC = () => {
  const width = window.screen.width;
  const dispatch = useAppDispatch();
  const { offset, limit, queryString } = useAppSelector(state => state.data);
  const login = useAppSelector(state => state.login);
  const navigate = useNavigate();

  const [appReady, setAppReady] = useState(false);
  const [resolve, setResolve] = useState(false);

  useEffect(() => {
    const tokenFromStorage = localStorage.getItem('app_premex');
    if (tokenFromStorage && !login.token) {
      dispatch(tokenReducer({ ...login, token: tokenFromStorage }));
    }
    setAppReady(true);
  }, [dispatch, login]);

  const getData = useGetDashboardQuery(
    {
      token: login.token,
      offset,
      limit,
      queryString
    },
    {
      skip: !login.token
    }
  );

  useEffect(() => {
    if (getData.data) {
      dispatch(dataReducer(getData.data));
      if (login.token) navigate('/main');
    }
  }, [getData.data, dispatch, login.token, navigate]);

  useEffect(() => {
    dispatch(loadingReducer(getData.isFetching));
  }, [getData.isFetching, dispatch]);

  useEffect(() => {
    if (width >= 1024) setResolve(true);
  }, [width]);

  if (!appReady) {
    return <div className="App"><p>Загрузка приложения...</p></div>;
  }

  return (
    <div className="App">
      {width >= 1024 ? (
        <Routes>
          <Route path="/" element={<Login />} />
          <Route
            path="/main"
            element={
              <ProtectedRoute>
                <MainPage resolve={resolve} />
              </ProtectedRoute>
            }
          />
          <Route path="/404" element={<Error404 />} />
          <Route path="/500" element={<Error500 />} />
          <Route path="/soon" element={<ComingSoon />} />
          <Route path="/mainten" element={<MaintenanceMode />} />
        </Routes>
      ) : (
        <h3 className="App_text">
          Для работы приложения необходимо разрешение экрана не менее 1024×768
        </h3>
      )}
    </div>
  );
};

export default App;
